"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formTempNameInfoApi = formTempNameInfoApi;
exports.getFormConfigEdit = getFormConfigEdit;
exports.getFormConfigInfo = getFormConfigInfo;
exports.getFormConfigList = getFormConfigList;
exports.getFormConfigSave = getFormConfigSave;
exports.notificationDetail = notificationDetail;
exports.notificationListApi = notificationListApi;
exports.notificationRoutine = notificationRoutine;
exports.notificationSms = notificationSms;
exports.notificationUpdate = notificationUpdate;
exports.notificationWechat = notificationWechat;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function getFormConfigInfo(params) {
  var data = {
    id: params.id
  };
  return (0, _request.default)({
    url: 'admin/platform/system/form/temp/info',
    method: 'GET',
    params: data
  });
}
function getFormConfigList(params) {
  var data = {
    keywords: params.keywords,
    page: params.page,
    limit: params.limit
  };
  return (0, _request.default)({
    url: 'admin/platform/system/form/temp/list',
    method: 'GET',
    params: data
  });
}
function getFormConfigSave(params) {
  var data = {
    content: params.content,
    info: params.info,
    name: params.name
  };
  return (0, _request.default)({
    url: 'admin/platform/system/form/temp/save',
    method: 'POST',
    data: data
  });
}
function getFormConfigEdit(params) {
  var p = {
    id: params.id
  };
  var data = {
    content: params.content,
    info: params.info,
    name: params.name
  };
  return (0, _request.default)({
    url: 'admin/platform/system/form/temp/update',
    method: 'POST',
    params: p,
    data: data
  });
}

/**
 * 系统通知列表
 * @param params
 */
function notificationListApi(params) {
  var data = {
    sendType: params.sendType
    //发送类型（1：通知会员，2：通知平台）
  };
  return (0, _request.default)({
    url: 'admin/platform/notification/list',
    method: 'GET',
    params: data
  });
}

/**
 * 小程序订阅模板开关
 * @param params
 */
function notificationRoutine(id) {
  return (0, _request.default)({
    url: "admin/platform/notification/routine/switch/".concat(id),
    method: 'post'
  });
}

/**
 * 公众号模板开关
 * @param params
 */
function notificationWechat(id) {
  return (0, _request.default)({
    url: "admin/platform/notification/wechat/switch/".concat(id),
    method: 'post'
  });
}

/**
 * 发送短信开关
 * @param params
 */
function notificationSms(id) {
  return (0, _request.default)({
    url: "admin/platform/notification/sms/switch/".concat(id),
    method: 'post'
  });
}

/**
 * 通知详情
 * @param params
 */
function notificationDetail(param) {
  var data = {
    detailType: param.type,
    id: param.id
  };
  return (0, _request.default)({
    url: "admin/platform/notification/detail",
    method: 'get',
    params: data
  });
}

//admin/system/notification/detail
/**
 * 修改通知
 * @param params
 */
function notificationUpdate(param) {
  var data = {
    detailType: param.type,
    id: param.id,
    status: param.status,
    tempId: param.tempId
  };
  return (0, _request.default)({
    url: "admin/platform/notification/update",
    method: 'post',
    data: data
  });
}

/**
 * 通过名称查询详情
 * @param params
 */
function formTempNameInfoApi(params) {
  return (0, _request.default)({
    url: "admin/platform/system/form/temp/name/info",
    method: 'get',
    params: params
  });
}